module.exports = __webpack_public_path__ + "img/sCallA.09a0de27.svg";